import Vue from "vue";

Vue.filter("parseJson", function (value: string): JSON {
  if (!value) return JSON.parse("{}");
  return JSON.parse(value.trim());
});
